module.exports = __webpack_public_path__ + "static/api-hero-6712efbe9c2a72183e646ea8b2727995.jpg";